import cardBlack from '@/assets/flashcards/card-black.svg';
import cardBlue from '@/assets/flashcards/card-blue.svg';
import cardDarkBlue from '@/assets/flashcards/card-dark-blue.svg';
import cardGreen from '@/assets/flashcards/card-green.svg';
import cardLightBlue from '@/assets/flashcards/card-light-blue.svg';
import cardLightOrange from '@/assets/flashcards/card-light-orange.svg';
import cardLightPurple from '@/assets/flashcards/card-light-purple.svg';
import cardLightRed from '@/assets/flashcards/card-light-red.svg';
import cardOrange from '@/assets/flashcards/card-orange.svg';
import cardPink from '@/assets/flashcards/card-pink.svg';
import cardPurple from '@/assets/flashcards/card-purple.svg';
import cardRed from '@/assets/flashcards/card-red.svg';
import cardWhite from '@/assets/flashcards/card-white.svg';
import cardYellow from '@/assets/flashcards/card-yellow.svg';

export type FlashcardFrame = {
  id: string;
  hex: string;
  frame: string;
  ink: string;
  speaker: string;
};

/** Same palette as mobile `CardColors` / decorative SVG frames. */
export const FLASHCARD_FRAMES: FlashcardFrame[] = [
  { id: 'BLACK', hex: '#1C1C1C', frame: cardBlack, ink: '#1C1C1C', speaker: '#1C1C1C80' },
  { id: 'DARK_BLUE', hex: '#13293D', frame: cardDarkBlue, ink: '#00487C', speaker: '#00487C80' },
  { id: 'BLUE', hex: '#00487C', frame: cardBlue, ink: '#13293D', speaker: '#13293D80' },
  { id: 'GREEN', hex: '#28780E', frame: cardGreen, ink: '#28780E', speaker: '#28780E80' },
  { id: 'ORANGE', hex: '#EB6402', frame: cardOrange, ink: '#EB6402', speaker: '#EB640280' },
  { id: 'PINK', hex: '#E44876', frame: cardPink, ink: '#E44876', speaker: '#E4487680' },
  { id: 'PURPLE', hex: '#44006B', frame: cardPurple, ink: '#44006B', speaker: '#44006B80' },
  { id: 'RED', hex: '#B90504', frame: cardRed, ink: '#B90504', speaker: '#B90504' },
  { id: 'WHITE', hex: '#A7A7A7', frame: cardWhite, ink: '#FFFFFF', speaker: '#FFFFFF80' },
  { id: 'YELLOW', hex: '#FFB800', frame: cardYellow, ink: '#8A6B12', speaker: '#FFB80080' },
  { id: 'LIGHT_PURPLE', hex: '#E6E6FF', frame: cardLightPurple, ink: '#333380', speaker: '#6060AA80' },
  { id: 'LIGHT_ORANGE', hex: '#FFD9B3', frame: cardLightOrange, ink: '#F15600', speaker: '#F1560080' },
  { id: 'LIGHT_BLUE', hex: '#B2DBFF', frame: cardLightBlue, ink: '#253F55', speaker: '#253F5580' },
  { id: 'LIGHT_RED', hex: '#FFE6EB', frame: cardLightRed, ink: '#C05A6E', speaker: '#C05A6E80' },
];

const BY_ID = new Map(FLASHCARD_FRAMES.map((frame) => [frame.id, frame]));
const BY_HEX = new Map(FLASHCARD_FRAMES.map((frame) => [frame.hex.toUpperCase(), frame]));

function normalizeColor(value: string | null | undefined): string {
  return (value ?? '').trim().replace(/^#/, '').toUpperCase();
}

export function resolveFlashcardFrame(
  color: string | null | undefined,
  fallbackIndex = 0,
): FlashcardFrame {
  const raw = (color ?? '').trim();
  if (raw) {
    const named = BY_ID.get(raw.toUpperCase().replace(/[\s-]+/g, '_'));
    if (named) return named;
    const hex = `#${normalizeColor(raw)}`;
    const exact = BY_HEX.get(hex);
    if (exact) return exact;
  }
  return FLASHCARD_FRAMES[((fallbackIndex % FLASHCARD_FRAMES.length) + FLASHCARD_FRAMES.length) % FLASHCARD_FRAMES.length];
}
